import React from 'react';
import { createRoot } from 'react-dom/client';
import { Engine } from 'babylonjs';
import { createScene } from './Scene';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

// Désactiver tous les logs en production
if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
}

window.addEventListener('load', async function () {
  const canvas = document.getElementById('renderCanvas');

  if (!canvas) {
    return; // Sortir si le canvas n'existe pas
  }

  let engine;

  try {
    engine = new Engine(canvas, true); // Utilisation exclusive de WebGL
  } catch (err) {
    console.error('Erreur lors de l\'initialisation du moteur :', err);
    return;
  }

  try {
    const { scene } = await createScene(canvas, engine);

    scene.executeWhenReady(() => {
      // Boucle de rendu
      engine.runRenderLoop(() => {
        scene.render();
      });

      // Animation de l'écran de chargement
      const loadingTop = document.getElementById('loadingTop');
      const loadingBottom = document.getElementById('loadingBottom');

      if (loadingTop && loadingBottom) {
        // Forcer un reflow avant d'ajouter les classes pour garantir que l'animation se déclenche
        void loadingTop.offsetHeight; // Forcer le reflow
        void loadingBottom.offsetHeight;

        setTimeout(() => {
          loadingTop.classList.add('slide-up');
          loadingBottom.classList.add('slide-down');
        }, 50); // Délai court pour permettre l'application des styles initiaux

        loadingBottom.addEventListener('transitionend', () => {
          const loadingScreen = document.getElementById('loadingScreen');
          if (loadingScreen) loadingScreen.remove();
        });
      } else {
        console.error('Éléments de chargement introuvables');
      }

      // Création du conteneur pour l'UI React
      let reactUIContainer = document.getElementById('react-ui');
      if (!reactUIContainer) {
        reactUIContainer = document.createElement('div');
        reactUIContainer.id = 'react-ui';
        document.body.appendChild(reactUIContainer);
      }

      // Montage de l'application React
      const root = createRoot(reactUIContainer);

      root.render(
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      );
    });
  } catch (err) {
    console.error('Une erreur est survenue :', err);
  }
});